<template>
  <div class="box">
    <div class="top">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="left-top">
            <div style="margin-top:10px;margin-left:10px">
              <img class="leftimg" :src="messages" />
              <span style="text-align: center;">基本信息</span>
            </div>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="12">
                <img style="margin: 25% 0 0 20%;" :src="ammeter" alt />
              </el-col>
              <el-col :span="12">
                <div style="margin-bottom:20px">
                  <p style="color:#b7adad">电量仪器设备编号</p>
                  <div>DLY002</div>
                </div>
                <div style="margin-bottom:20px">
                  <p style="color:#b7adad">设备型号</p>
                  <div>DLY002</div>
                </div>
                <div style="margin-bottom:20px">
                  <p style="color:#b7adad">设备位置</p>
                  <div>配电室</div>
                </div>
                <div style="margin-bottom:20px">
                  <p style="color:#b7adad">设备描述</p>
                  <div>对供电电源的多项供电参数实时监测</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="right-top">
            <el-row>
              <el-col :span="20">
                <div style="margin-top:10px;margin-left:10px">
                  <img class="leftimg" :src="parameter" />
                  <span style="text-align: center;">运行参数</span>
                </div>
              </el-col>
              <el-col :span="4">
                <!-- <div
                  style="display: flex;justify-content: space-between;margin-right:25px;width: 100%"
                >
                  <div style="margin-top:10px">
                    <img class="leftimgright" :src="normal" />
                    <span style="text-align: center;">正常</span>
                  </div>
                  <div style="margin-top:10px">
                    <img class="leftimgright" :src="abnormal" />
                    <span style="text-align: center;">告警</span>
                  </div>
                </div>-->
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="10" class="leftyxfxbox">
                <div class="leftyxcs">
                  <div class="leftyxcsTop">
                    <div class="piechart">
                      <div :id="pieone" class="guanBox"></div>
                    </div>
                    <div class="piechart">
                      <div :id="pietwo" class="guanBox"></div>
                    </div>
                    <div class="piechart">
                      <div :id="piethree" class="guanBox"></div>
                    </div>
                  </div>
                  <div class="leftyxcsBottom">
                    <div class="piechart">
                      <div :id="piefour" class="guanBox"></div>
                    </div>
                    <div class="piechart">
                      <div :id="piefive" class="guanBox"></div>
                    </div>
                    <div class="piechart">
                      <div :id="piesix" class="guanBox"></div>
                    </div>
                  </div>
                </div>
              </el-col>

              <el-col :span="14">
                <el-row>
                  <el-col :span="12">
                    <div class="leftcs">
                      <div class="glwz">
                        <span>A相功率(KW):</span>
                        <span class="ztsize">{{ gl_A }}</span>
                      </div>
                      <div class="glwz">
                        <span>B相功率(KW):</span>
                        <span class="ztsize">{{ gl_B }}</span>
                      </div>
                      <div class="glwz">
                        <span>C相功率(KW):</span>
                        <span class="ztsize">{{ gl_C }}</span>
                      </div>
                      <div class="glwz">
                        <span>A相视在功率(VA):</span>
                        <span class="ztsize">{{ szgl_A }}</span>
                      </div>
                      <div class="glwz">
                        <span>B相视在功率(VA):</span>
                        <span class="ztsize">{{ szgl_B }}</span>
                      </div>
                      <div class="glwz">
                        <span>C相视在功率(VA):</span>
                        <span class="ztsize">{{ szgl_C }}</span>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12">
                    <div class="rightcs">
                      <div class="glwz">
                        <span>频率(Hz):</span>
                        <span class="ztsize">{{ pl }}</span>
                      </div>
                      <div class="glwz">
                        <span>零序电流(A):</span>
                        <span class="ztsize">{{ lxdl }}</span>
                      </div>
                      <div class="glwz">
                        <span>总功率因素(cosΦ):</span>
                        <span class="ztsize">{{ zglys }}</span>
                      </div>
                      <div class="glwz">
                        <span>总视在功率(VA):</span>
                        <span class="ztsize">{{ zszgl }}</span>
                      </div>
                      <div class="glwz">
                        <span>总无功功率(Var):</span>
                        <span class="ztsize">{{ zwggl }}</span>
                      </div>
                      <div class="glwz">
                        <span>总有功功率(KW):</span>
                        <span class="ztsize">{{ zyggl }}</span>
                      </div>
                    </div>
                  </el-col>
                </el-row>
                <div class="glwz1">
                  <span style="margin-left:10px">电能示值(KWh):</span>
                  <span class="ztsize" style="margin-right:30px">{{
                    dnsz
                  }}</span>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="middletab">
      <el-tabs
        style="margin-left:50px"
        v-model="activeName"
        @tab-click="getData(activeName)"
      >
        <el-tab-pane label="电流" name="dl"></el-tab-pane>
        <el-tab-pane label="电压" name="dy"></el-tab-pane>
        <el-tab-pane label="功率" name="gl"></el-tab-pane>
        <el-tab-pane label="功率因素" name="glys"></el-tab-pane>
        <el-tab-pane label="频率" name="pl"></el-tab-pane>
        <el-tab-pane label="用电量" name="ydl"></el-tab-pane>
        <el-tab-pane label="负荷率" name="fhl"></el-tab-pane>
        <el-tab-pane label="不平衡度" name="bphd"></el-tab-pane>
      </el-tabs>
      <div style="margin: 6px 20px 0 0;">
        <!-- <a @click="toId()" class="tzlj" href="javascript:void(0)">运行分析</a> -->
      </div>
    </div>
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="bottom">
          <div id="echartsId"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getDate,
  findDataByParam,
  formatDate,
  formatTime,
  getX,
} from "@/utils/index";
import handleData from "@/utils/handleData.js";
import * as fpg from "@/utils/fpg.js";
import { isNull, isUndefined } from "util";
import uuidv1 from "uuid/v1";
import messages from "./xx.png";
import parameter from "./cs.png";
import ammeter from "./db.png";
import normal from "./zc.png";
import abnormal from "./yc.png";
import dateTool from "@/utils/dateTool";
export default {
  name: "realtimgData",
  props: {
    TomeasureId: {
      type: String,
      default: () => {},
    },
  },
  watch: {
    TomeasureId: function(newVal, oldVal) {
      // this.measuresId = newVal;
      // console.log(this.measuresId);
      console.log(newVal);
      this.measuresId = newVal;
      this.getData();
      this.getfirstsockdata();
    },
  },
  data() {
    return {
      measures: [],
      measuresId: "",
      lenged: [],
      pieone: uuidv1(),
      pietwo: uuidv1(),
      piethree: uuidv1(),
      piefour: uuidv1(),
      piefive: uuidv1(),
      piesix: uuidv1(),
      messages: messages,
      parameter: parameter,
      ammeter: ammeter,
      normal: normal,
      abnormal: abnormal,
      activeName: "dl",
      myChart: null,
      newMychartone: null,
      newMycharttwo: null,
      newMychartthree: null,
      newMychartfour: null,
      newMychartfive: null,
      newMychartsix: null,
      title: "",
      dw: "",
      barDate1: {
        xdata: [],
        seriesData: [], //data
        lenged: [],
        seriesDataNew: [], //time {time ,value}
      },
      volt_A: "-",
      volt_B: "-",
      volt_C: "-",
      curr_A: "-",
      curr_B: "-",
      curr_C: "-",
      gl_A: "-",
      gl_B: "-",
      gl_C: "-",
      szgl_A: "-",
      szgl_B: "-",
      szgl_C: "-",
      pl: "-",
      lxdl: "-",
      zglys: "-",
      zszgl: "-",
      zwggl: "-",
      zyggl: "-",
      dnsz: "-",
      timer: null,
    };
  },
  created() {
    console.log(this.TomeasureId);
    this.bus.$on("formClose", (a) => {
      console.log(a);
      if (a == "clear") {
        clearInterval(this.timer);
        this.timer = null;
      }
    });
    this.measuresId = this.TomeasureId;
  },
  mounted() {
    this.getData();
    this.getfirstsockdata();
    this.getMeasureParams();
  },
  beforeDestroy() {
    //            清楚定时器
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    toId() {
      console.log("111");
    },
    getMeasureParams() {
      let vm = this;
      vm.$api.measure.getMeasureParams(vm.measuresId).then((res) => {
        console.log(res);
      });
    },
    getfirstsockdata() {
      let vm = this;
      // let measures = "300000000092";
      let code = [
        "201",
        "202",
        "203",
        "207",
        "208",
        "209",
        "212",
        "213",
        "214",
        "224",
        "225",
        "226",
        "227",
        "210",
        "219",
        "223",
        "215",
        "211",
        "229",
      ];

      // console.log(res);
      // console.log(res.data[0].data);
      // // this.wockdata = res.data;
      // for (let i = 0; i < res.data[0].data.length; i++) {
      //   // console.log(res.data[0].data[i].pointCode);
      //   code.push(res.data[0].data[i].pointCode);
      // }
      console.log(code);
      this.timer = setInterval(() => {
        for (let j = 0; j < code.length; j++) {
          switch (code[j]) {
            case "201":
              vm.volt_A =
                vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                  id: this.measuresId,
                  code: code[j],
                  num: "0",
                }) == "-"
                  ? "0"
                  : vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                      id: this.measuresId,
                      code: code[j],
                      num: "0",
                    });
              // console.log(code[j]);
              // console.log(vm.volt_A);
              break;
            case "202":
              vm.volt_B =
                vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                  id: this.measuresId,
                  code: code[j],
                  num: "0",
                }) == "-"
                  ? "0"
                  : vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                      id: this.measuresId,
                      code: code[j],
                      num: "0",
                    });
              // console.log(code[j]);
              // console.log(vm.volt_B);
              break;

            case "203":
              vm.volt_C =
                vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                  id: this.measuresId,
                  code: code[j],
                  num: "0",
                }) == "-"
                  ? "0"
                  : vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                      id: this.measuresId,
                      code: code[j],
                      num: "0",
                    });
              break;
            // console.log(code[j]);
            case "207":
              vm.curr_A =
                vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                  id: this.measuresId,
                  code: code[j],
                  num: "0",
                }) == "-"
                  ? "0"
                  : vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                      id: this.measuresId,
                      code: code[j],
                      num: "0",
                    });
              break;
            case "208":
              vm.curr_B =
                vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                  id: this.measuresId,
                  code: code[j],
                  num: "0",
                }) == "-"
                  ? "0"
                  : vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                      id: this.measuresId,
                      code: code[j],
                      num: "0",
                    });
              break;
            case "209":
              vm.curr_C =
                vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                  id: this.measuresId,
                  code: code[j],
                  num: "0",
                }) == "-"
                  ? "0"
                  : vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                      id: this.measuresId,
                      code: code[j],
                      num: "0",
                    });
              break;
            case "212":
              vm.gl_A = vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                id: this.measuresId,
                code: code[j],
                num: "0",
              });
              break;
            case "213":
              vm.gl_B = vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                id: this.measuresId,
                code: code[j],
                num: "0",
              });
              break;
            case "214":
              vm.gl_C = vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                id: this.measuresId,
                code: code[j],
                num: "0",
              });
              break;
            case "224":
              vm.szgl_A = vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                id: this.measuresId,
                code: code[j],
                num: "0",
              });
              break;
            case "225":
              vm.szgl_B = vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                id: this.measuresId,
                code: code[j],
                num: "0",
              });
              break;
            case "226":
              vm.szgl_C = vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                id: this.measuresId,
                code: code[j],
                num: "0",
              });
              break;
            case "227":
              vm.pl = vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                id: this.measuresId,
                code: code[j],
                num: "0",
              });
              break;
            case "210":
              vm.lxdl = vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                id: this.measuresId,
                code: code[j],
                num: "0",
              });
              break;
            case "219":
              vm.zglys = vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                id: this.measuresId,
                code: code[j],
                num: "0",
              });
              break;
            case "223":
              vm.zszgl = vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                id: this.measuresId,
                code: code[j],
                num: "0",
              });
              break;
            case "215":
              vm.zwggl = vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                id: this.measuresId,
                code: code[j],
                num: "0",
              });
              break;
            case "211":
              vm.zyggl = vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                id: this.measuresId,
                code: code[j],
                num: "0",
              });
              break;
            case "229":
              vm.dnsz = vm.$store.getters["point/GET_POINT_CODE_NUM"]({
                id: this.measuresId,
                code: code[j],
                num: "0",
              });
              break;
            default:
          }
          // const value = vm.$store.getters["point/GET_POINT_CODE_NUM"]({
          //   id: this.measuresId,
          //   code: code[j],
          //   num: "0"
          // });
          // console.log(value);
        }
        this.getPieEchart(
          this.pieone,
          this.newMychartone,
          "A相电压",
          "V",
          this.volt_A,
          500
        );
        this.getPieEchart(
          this.pietwo,
          this.newMycharttwo,
          "B相电压",
          "V",
          this.volt_B,
          500
        );
        this.getPieEchart(
          this.piethree,
          this.newMychartthree,
          "C相电压",
          "V",
          this.volt_C,
          500
        );
        this.getPieEchart(
          this.piefour,
          this.newMychartfour,
          "A相电流",
          "A",
          this.curr_A,
          200000
        );
        this.getPieEchart(
          this.piefive,
          this.newMychartfive,
          "B相电流",
          "A",
          this.curr_B,
          200000
        );
        this.getPieEchart(
          this.piesix,
          this.newMychartsix,
          "C相电流",
          "A",
          this.curr_C,
          200000
        );
      }, 2000);

      // const value = vm.$store.getters["point/GET_POINT_CODE_NUM"]({
      //   id: 300000000092,
      //   code: "230",
      //   num: "0"
      // });
      // console.log(value);
    },
    getEchart(obj) {
      let this_ = this;
      this.myChart = this.$echarts.init(document.getElementById("echartsId"));
      var option = {
        title: {
          text: this_.title,
          left: "center",
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        legend: {
          height: "80%",
          left: "center",
          top: "12%",
          data: obj.lenged,
        },
        dataZoom: [
          {
            type: "inside",
            show: true,
            realtime: true,
          },
          {
            show: true,
            realtime: true,
            end: 100,
            type: "slider",
            width: "92%",
            left: "center",
          },
        ],
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          // bottom: "3%",
          top: "90px",
          height: "240px",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: obj.x,
          },
        ],
        yAxis: [
          {
            name: this_.dw,
            type: "value",
          },
        ],
        series: obj.series,
      };
      this_.myChart.setOption(option, true);
      if (this_.myChart) {
        window.addEventListener("resize", function() {
          this_.myChart.resize();
        });
      }
    },
    getPieEchart(uid, newMychart, title, titlename, data, max) {
      let this_ = this;
      newMychart = this_.$echarts.init(document.getElementById(uid));
      var option = {
        title: {
          text: title, //标题文本内容
        },
        toolbox: {
          //可视化的工具箱
          show: true,
          feature: {
            // restore: {
            //   //重置
            //   show: true
            // },
            // saveAsImage: {
            //   //保存图片
            //   show: true
            // }
          },
        },
        // tooltip: {
        //   //弹窗组件
        //   formatter: "{b}：{c}"
        // },
        series: [
          {
            // name: "业务指标",
            // title: "单片用电",
            type: "gauge",
            center: ["50%", "65%"],
            data: [{ value: data, name: "(" + titlename + ")" }],
            min: 0, // 最小的数据值,默认 0 。映射到 minAngle。
            max: max, // 最大的数据值,默认 100 。映射到 maxAngle。
            splitNumber: "none",
            radius: "50",
            fontSize: 6,
            startAngle: 180, // 仪表盘起始角度,默认 225。圆心 正右手侧为0度，正上方为90度，正左手侧为180度。
            endAngle: 0, // 仪表盘结束角度,默认 -45
            axisLine: {
              // 坐标轴线
              // length: 30,
              lineStyle: {
                // 属性lineStyle控制线条样式
                width: 8,
                color: [
                  [0.7, "#206ee3"],
                  // [0.5, "#63869e"],
                  [1, "#c23531"],
                ],
              },
            },
            title: {
              // 仪表盘标题。
              show: true, // 是否显示标题,默认 true。
              offsetCenter: [0, "30%"], //相对于仪表盘中心的偏移位置，数组第一项是水平方向的偏移，第二项是垂直方向的偏移。可以是绝对的数值，也可以是相对于仪表盘半径的百分比。
              color: "#111", // 文字的颜色,默认 #333。
              fontSize: 12, // 文字的字体大小,默认 15。
            },
            detail: {
              // 仪表盘详情，用于显示数据。
              show: true, // 是否显示详情,默认 true。
              offsetCenter: [0, "70%"], // 相对于仪表盘中心的偏移位置，数组第一项是水平方向的偏移，第二项是垂直方向的偏移。可以是绝对的数值，也可以是相对于仪表盘半径的百分比。
              color: "auto", // 文字的颜色,默认 auto。
              fontSize: 25, // 文字的字体大小,默认 15。
              formatter: "{value}", // 格式化函数或者字符串
            },
            pointer: {
              // 仪表盘指针。
              show: true, // 是否显示指针,默认 true。
              length: "90%", // 指针长度，可以是绝对数值，也可以是相对于半径的百分比,默认 80%。
              width: 6, // 指针宽度,默认 8。
            },
            itemStyle: {
              // 仪表盘指针样式。
              color: "auto", // 指针颜色，默认(auto)取数值所在的区间的颜色
              opacity: 1, // 图形透明度。支持从 0 到 1 的数字，为 0 时不绘制该图形。
              borderWidth: 0, // 描边线宽,默认 0。为 0 时无描边。
              borderType: "solid", // 柱条的描边类型，默认为实线，支持 'solid', 'dashed', 'dotted'。
              borderColor: "#000", // 图形的描边颜色,默认 "#000"。支持的颜色格式同 color，不支持回调函数。
              shadowBlur: 10, // (发光效果)图形阴影的模糊大小。该属性配合 shadowColor,shadowOffsetX, shadowOffsetY 一起设置图形的阴影效果。
              shadowColor: "#fff", // 阴影颜色。支持的格式同color。
            },
          },
        ],
      };

      // setInterval(function() {
      //   option.series[0].data[0].value = (Math.random() * 100).toFixed(2) - 0;
      //   newMychart.setOption(option, true);
      // }, 2000);
      newMychart.setOption(option, true);
      window.addEventListener("resize", function() {
        newMychart.resize();
      });
    },
    getData() {
      let vm = this;
      //   dateTool.format(time,'yyyy-MM-dd ')+"00:00:00"
      let fromtime = dateTool.format(new Date(), "yyyy-MM-dd") + " 00:00:00";
      let nextDay = new Date();
      nextDay.setDate(nextDay.getDate() + 1);
      let totime = dateTool.format(nextDay, "yyyy-MM-dd") + " 00:00:00";
      this.measures = [];
      if (this.activeName == "dl") {
        this.measures = [
          { measureId: this.measuresId, pointNumber: 0, pointCode: "207" },
          { measureId: this.measuresId, pointNumber: 0, pointCode: "208" },
          { measureId: this.measuresId, pointNumber: 0, pointCode: "209" },
        ];
        this.lenged = ["A相", "B相", "C相"];
        this.title = "电流";
        this.dw = "A";
      } else if (this.activeName == "dy") {
        this.measures = [
          { measureId: this.measuresId, pointNumber: 0, pointCode: "201" },
          { measureId: this.measuresId, pointNumber: 0, pointCode: "202" },
          { measureId: this.measuresId, pointNumber: 0, pointCode: "203" },
        ];
        this.lenged = ["A相", "B相", "C相"];
        this.title = "电压";
        this.dw = "V";
      } else if (this.activeName == "gl") {
        this.measures = [
          { measureId: this.measuresId, pointNumber: 0, pointCode: "211" },
          { measureId: this.measuresId, pointNumber: 0, pointCode: "215" },
          { measureId: this.measuresId, pointNumber: 0, pointCode: "223" },
        ];
        this.lenged = ["总有功功率(kW)", "总无功功率(kVar)", "总视在功率(kVA)"];
        this.title = "功率";
        this.dw = "kW";
      } else if (this.activeName == "glys") {
        this.measures = [
          { measureId: this.measuresId, pointNumber: 0, pointCode: "219" },
          { measureId: this.measuresId, pointNumber: 0, pointCode: "220" },
          { measureId: this.measuresId, pointNumber: 0, pointCode: "221" },
          { measureId: this.measuresId, pointNumber: 0, pointCode: "222" },
        ];
        this.title = "功率因数";
        this.lenged = [
          "总功率因素",
          "A相功率因素",
          "B相功率因素",
          "C相功率因素",
        ];
        this.dw = "";
      } else if (this.activeName == "pl") {
        this.measures = [
          { measureId: this.measuresId, pointNumber: 0, pointCode: "227" },
        ];
        this.lenged = ["频率"];
        this.title = "频率";
        this.dw = "Hz";
      } else if (this.activeName == "ydl") {
        this.measures = [
          { measureId: this.measuresId, pointNumber: 0, pointCode: "100229" },
        ];
        this.lenged = ["用电量"];
        this.title = "用电量";
        this.dw = "kWh";
        this.$api.quantity
          .getQuantityHour2(this.measures, fromtime, totime, 0)
          .then((res) => {
            console.log(res);
            let timeData = fpg.getMatchTime(fromtime, totime, "1", true);
            console.log(timeData);
            this.barDate1 = {
              xdata: [],
              seriesDataNew: [],
              lenged: [],
              seriesData: [],
            };
            let xdata1 = handleData.createXData("0", fromtime, totime); //获取柱状图x轴
            this.barDate1.xdata = [];
            for (let i = 0; i < xdata1.length; i++) {
              this.barDate1.xdata.push(xdata1[i].title);
            }
            // console.log(this.barDate1);
            let data = [];
            for (let i = 0; i < res.data.length; i++) {
              console.log(res.data[i].data);
              vm.barDate1.seriesDataNew.push([]);
              vm.barDate1.seriesData.push([]);
              vm.barDate1.seriesDataNew[i] = JSON.parse(
                JSON.stringify(timeData)
              );
              data.push(res.data[i].data);
              vm.barDate1.lenged = vm.lenged;
            }

            for (let k = 0; k < vm.barDate1.seriesDataNew.length; k++) {
              for (let j = 0; j < data[k].length; j++) {
                let elem = vm.barDate1.seriesDataNew[k];
                let item = elem.find((obj) => {
                  return obj.time == data[k][j].time.slice(0, 13);
                });
                if (item) {
                  item.value = isNull(data[k][j].value)
                    ? ""
                    : data[k][j].value.toFixed(2);
                }
              }
            }
            for (let i = 0; i < vm.barDate1.seriesDataNew.length; i++) {
              let pieValue = 0;
              let value = 0;
              for (let j = 0; j < vm.barDate1.seriesDataNew[i].length; j++) {
                vm.barDate1.seriesData[i][j] =
                  vm.barDate1.seriesDataNew[i][j].value;
              }
            }
            let obj = vm.initData(vm.barDate1);
            vm.getEchart(obj);
          });
        return;
      } else if (this.activeName == "fhl") {
        this.measures = [
          { measureId: this.measuresId, pointNumber: 0, pointCode: "233" },
        ];
        this.lenged = ["负荷率"];
        this.title = "负荷率";
        this.dw = "%";
        this.$api.quantity
          .getQuantityHour2(this.measures, fromtime, totime, 0)
          .then((res) => {
            console.log(res);
            let timeData = fpg.getMatchTime(fromtime, totime, "1", true);
            console.log(timeData);
            this.barDate1 = {
              xdata: [],
              seriesDataNew: [],
              lenged: [],
              seriesData: [],
            };
            let xdata1 = handleData.createXData("0", fromtime, totime); //获取柱状图x轴
            this.barDate1.xdata = [];
            for (let i = 0; i < xdata1.length; i++) {
              this.barDate1.xdata.push(xdata1[i].title);
            }
            // console.log(this.barDate1);
            let data = [];
            for (let i = 0; i < res.data.length; i++) {
              console.log(res.data[i].data);
              vm.barDate1.seriesDataNew.push([]);
              vm.barDate1.seriesData.push([]);
              vm.barDate1.seriesDataNew[i] = JSON.parse(
                JSON.stringify(timeData)
              );
              data.push(res.data[i].data);
              vm.barDate1.lenged = vm.lenged;
            }
            for (let k = 0; k < vm.barDate1.seriesDataNew.length; k++) {
              for (let j = 0; j < data[k].length; j++) {
                let elem = vm.barDate1.seriesDataNew[k];
                let item = elem.find((obj) => {
                  return obj.time == data[k][j].time.slice(0, 13);
                });
                if (item) {
                  item.value = isNull(data[k][j].value)
                    ? ""
                    : data[k][j].value.toFixed(2);
                }
              }
            }
            for (let i = 0; i < vm.barDate1.seriesDataNew.length; i++) {
              let pieValue = 0;
              let value = 0;
              for (let j = 0; j < vm.barDate1.seriesDataNew[i].length; j++) {
                vm.barDate1.seriesData[i][j] =
                  vm.barDate1.seriesDataNew[i][j].value;
              }
            }
            console.log(vm.barDate1);
            let obj = vm.initData(vm.barDate1);
            console.log(obj);
            vm.getEchart(obj);
          });
        return;
      } else if (this.activeName == "bphd") {
        this.measures = [
          { measureId: this.measuresId, pointNumber: 0, pointCode: "235" },
          { measureId: this.measuresId, pointNumber: 0, pointCode: "242" },
        ];
        this.lenged = ["电压不平衡度", "电流不平衡度"];
        this.title = "不平衡度";
        this.dw = "%";
      }

      this.$api.measuring
        .getMeasuringValueHour2(this.measures, fromtime, totime, 0)
        .then((res) => {
          console.log(res);

          let timeData = fpg.getMatchTime(fromtime, totime, "1", true);
          console.log(timeData);
          this.barDate1 = {
            xdata: [],
            seriesDataNew: [],
            lenged: [],
            seriesData: [],
          };
          let xdata1 = handleData.createXData("0", fromtime, totime); //获取柱状图x轴
          this.barDate1.xdata = [];
          for (let i = 0; i < xdata1.length; i++) {
            this.barDate1.xdata.push(xdata1[i].title);
          }
          // console.log(this.barDate1);
          let data = [];
          for (let i = 0; i < res.data.length; i++) {
            console.log(res.data[i].data.data);
            vm.barDate1.seriesDataNew.push([]);
            vm.barDate1.seriesData.push([]);
            vm.barDate1.seriesDataNew[i] = JSON.parse(JSON.stringify(timeData));
            data.push(res.data[i].data.data);
            vm.barDate1.lenged = vm.lenged;
          }

          // for (let i = 0; i < data.length; i++) {

          // for (let k = 0; k < data.length; k++) {
          //   for (let j = 0; j < data[k].length; j++) {
          //     // [j]);
          //     [k][j].time.slice(0, 13));
          //     console.log(vm.barDate1.seriesDataNew[k][j].time);
          //     console.log(
          //       data[k][j].time.slice(0, 13) ==
          //         vm.barDate1.seriesDataNew[k][j].time
          //     );
          //     if (
          //       data[k][j].time.slice(0, 13) ==
          //       vm.barDate1.seriesDataNew[k][j].time
          //     ) {
          //       vm.barDate1.seriesDataNew[k][j].value = isNull(data[k][j].value)
          //         ? ""
          //         : data[k][j].value.toFixed(2);
          //     }
          //   }
          // }
          // }

          //
          for (let k = 0; k < vm.barDate1.seriesDataNew.length; k++) {
            for (let j = 0; j < data[k].length; j++) {
              let elem = vm.barDate1.seriesDataNew[k];
              let item = elem.find((obj) => {
                return obj.time == data[k][j].time.slice(0, 13);
              });
              if (item) {
                item.value = isNull(data[k][j].value)
                  ? ""
                  : data[k][j].value.toFixed(2);
              }
            }
          }
          // }
          //

          console.log(vm.barDate1);
          for (let i = 0; i < vm.barDate1.seriesDataNew.length; i++) {
            for (let j = 0; j < vm.barDate1.seriesDataNew[i].length; j++) {
              vm.barDate1.seriesData[i][j] =
                vm.barDate1.seriesDataNew[i][j].value;
            }
          }
          console.log(vm.barDate1);
          let obj = vm.initData(vm.barDate1);
          console.log(obj);
          vm.getEchart(obj);
        });
    },
    //初始化数据
    initData(curval) {
      console.log(curval);
      let obj = {
        x: curval.xdata,
        lenged: curval.lenged,
        series: (function() {
          let arrData = [];
          for (let i = 0; i < curval.seriesData.length; i++) {
            arrData.push({
              name: curval.lenged[i],
              type: "line",
              data: curval.seriesData[i],
              symbol: "circle",
              showAllSymbol: true,
              symbolSize: 8,
              // stack:"bar",
              // label: {
              //   show: true,
              //   position: "top",
              //   color: "#8A9099"
              // }
            });
          }
          return arrData;
        })(),
      };
      return obj;
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 98%;
  height: 500px;
  padding: 14px;
  background: #f5f5f5;
  overflow: auto;
}
.top {
  margin-bottom: 14px;
}
.left-top {
  // display: flex;
  background: #fff;
  border: 1px solid #eee;
  height: 365px;
  border-radius: 10px;
}
.right-top {
  background: #fff;
  border: 1px solid #eee;
  height: 365px;
  border-radius: 10px;
}
.bottom {
  background: #fff;
  border: 1px solid #eee;
  height: 365px;
  border-radius: 10px;
}
.leftimg {
  vertical-align: middle;
  width: 25px;
  height: 25px;
  // display: block;
}
.leftimgright {
  vertical-align: middle;
  width: 30px;
  height: 25px;
}
::v-deep .el-divider {
  margin: 10px 0;
}
.leftyxcs {
  height: 300px;
  border-right: 1px solid #d0c9c9;
  margin-left: 15px;
  display: flex;
  flex-flow: column;
}
.leftyxcsTop {
  display: flex;
  flex: 1;
  flex-flow: row;
}
.leftyxcsBottom {
  display: flex;
  flex: 1;
  flex-flow: row;
}
.piechart {
  // display: inline-block;
  // width: 29%;
  // height: 38%;
  display: flex;
  flex: 1;
  background: #f5f5f5f5;
  border: 1px solid #d0c9c9;
  margin-right: 12px;
  margin-bottom: 12px;
  border-radius: 8px;
  // float: left;
  // width: 33%;
  // height: 33%;
  // margin-left:5px
}
.leftcs {
  padding-left: 10px;
  width: 90%;
}
.glwz {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.glwz1 {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.rightcs {
  width: 90%;
}
.ztsize {
  color: #51af16;
  font-size: 23px;
}
#echartsId {
  width: 100%;
  // height: calc(100% - 20px);
  height: 100%;
  overflow: hidden;
}
.middletab {
  display: flex;
  justify-content: space-between;
  height: 35px;
  background: #dbdbdb;
  margin-bottom: 14px;
  border-radius: 5px;
}
::v-deep .el-tabs__item {
  height: 36px;
  font-size: 16px;
  font-weight: 600;
}
::v-deep .el-tabs__active-bar {
  height: 4px;
}
.tzlj {
  text-decoration: none;
  flex-direction: column-reverse;
  font-size: 16px;
  font-weight: 600;
  color: #409eff;
}
.guanBox {
  width: 100%;
  height: 100%;
}
</style>
